import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, combineLatest } from 'rxjs';
import { mergeMap, takeUntil } from 'rxjs/operators';

import { ActivatedRoute } from '@angular/router';
import { Country } from '../../models/country';
import { CountryService } from '../../services/country-service/country.service';
import { FormControl } from '@angular/forms';
import { Profile } from '../../models/profile';
import { ProfileService } from '../../services/profile-service/profile.service';

@Component({
    selector: 'prof-tos-cards',
    templateUrl: './tos-cards.component.html',
    styleUrls: ['./tos-cards.component.scss'],
    standalone: false
})
export class TosCardsComponent implements OnInit, OnDestroy {
  public profile: Profile;
  public countries: Country[];
  public selectedCountry = new FormControl();

  private onDestroy$ = new Subject<void>();

  constructor(
    private _profSvc: ProfileService,
    private _countrySvc: CountryService,
    private _route: ActivatedRoute
  ) {}

  ngOnInit() {
    combineLatest([
      this._route.queryParams,
      this._countrySvc.countries$,
    ])
    .pipe(
      takeUntil(this.onDestroy$),
      mergeMap(([params, countryData]) => {
        this.countries = countryData;
        if (params.code && params.code !== '') {
          this.selectedCountry.setValue(params.code);
        }
        return this._profSvc.profile$;
      }),
    )
    .subscribe(profileData => {
        this.profile = profileData;
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }
}
